import { FC } from 'react';
import { Box, BoxProps, Flex, FlexProps, useToken } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import * as ContentLayout from 'layouts/ContentLayout';

export const { Root } = ContentLayout;

export const Body: FC<ContentLayout.BodyProps> = (props) => (
  <ContentLayout.Body isScrollable={false} paddingBottom="0" {...props} />
);

export const Sidebar: FC<ContentLayout.SidebarProps> = (props) => (
  <ContentLayout.Sidebar
    alignItems="center"
    backgroundColor="grey.100"
    justifyContent="center"
    paddingBottom="space-64"
    sx={{ '> img': { height: 256, width: 256 } }}
    {...props}
  />
);

export const SidebarWithContent: FCWithChildren = (props) => (
  <ContentLayout.Sidebar
    paddingBottom="0"
    paddingLeft="space-24"
    paddingRight="space-24"
    paddingTop="space-32"
    {...props}
  />
);

export const HeaderButtonsContainer: FC<FlexProps & { size?: string }> = ({
  ...props
}) => {
  return (
    <Flex
      bgColor="white"
      paddingBottom="space-16"
      paddingTop="space-40"
      position="absolute"
      top="0"
      width="full"
      zIndex="sticky"
      {...props}
    />
  );
};

export const FooterContainer: FC<BoxProps> = (props) => {
  return (
    <Box
      bgColor="white"
      bottom="0"
      position="sticky"
      zIndex="sticky"
      {...props}
    />
  );
};

export const FooterButtonsContainer: FC<FlexProps> = (props) => {
  return <Flex justifyContent="flex-end" padding="space-16" {...props} />;
};

export const ContentsContainer: FC<FlexProps> = (props) => {
  const [space32] = useToken('space', ['space-32']);

  return (
    <Flex
      css={{ scrollbarGutter: 'stable' }}
      flexDirection="column"
      flexGrow={1}
      marginLeft="-space-16"
      // we need a bottom padding so the stepper footer is not
      // dragged upward on end of scroll
      paddingBottom="space-32"
      // we need a top padding to give some space for the absolutely
      // positionned header
      paddingTop="space-64"
      // The computation below is here to reserve space on the horizontal borders.
      // Without it, elements that overflow by some pixels (the top-right icon
      // in WarningBox for instance, or the shadows of Card) end up making the div
      // overflow-x scroll, even when the property is explicitly fixed.
      paddingX="space-16"
      width={`calc(100% + ${space32})`}
      {...props}
    />
  );
};
